function useKeyboardClick(element, keys = ['Enter', ' ']) {
  const handleKeyDown = (event) => {
    if (keys.indexOf(event.key) !== -1) {
      event.stopPropagation();
      element.click();
    }
    element.removeEventListener('keydown', handleKeyDown, false);
  };
  const handleKeyUp = () => {
    element.addEventListener('keydown', handleKeyDown, false);
  };
  element.addEventListener('keyup', handleKeyUp, false);
  element.addEventListener('keydown', handleKeyDown, false);
  return function useEscapeCleanup() {
    element.removeEventListener('keyup', handleKeyUp, false);
    element.removeEventListener('keydown', handleKeyDown, false);
  };
}

export { useKeyboardClick as u };

//# sourceMappingURL=utils.js.map